import ICurrentUser from "../entities/helper/ICurrentUser";
import ISearch from "../entities/helper/ISearch";
import { IActoCondicionSubestandar, ISearchAllActoCondicionSubestandar } from "../entities/IActoCondicionSubestandar";
import { IArbolCausal } from "../entities/IArbolCausal";
import { ICapacidades } from "../entities/ICapacidades";
import { ICausaBasica, IAddCausaBasica } from "../entities/ICausaBasica";
import { IAddCausaInmediata, ICausaInmediata } from "../entities/ICausaInmediata";
import { IAddCausaSistema, ICausaSistema } from "../entities/ICausaSistema";
import {
  ICalculoDesviacion,
  ICausa,
  ICausasAsignadasYCompletadas,
  IDesviacion,
  IEnviarDesviacion,
  ISearchAllCapacidad,
  ISearchAllFactoresPersonales,
  ISearchAllTipoCausaBasica,
  ISearchByExcelReporteHistoricoDesviacion,
  ISearchByHistoricoDesviacion,
  ISearchByReporteACCausasBasicas,
  ISearchByReporteACCausasInmediatas,
  ISearchByReporteACCausasSistema,
  ISearchByReporteAnalisisCausal,
  ISearchByReporteDesviacion,
  ISearchByReporteSabanaDesviacion,
  ISearchByTipoBusqueda,
  ISearchByTipoBusquedaDesviaciones,
  ISearchDocumentosAnalisisCausal,
  ISetCierreDesviacion,
} from "../entities/IDesviacion";
import IDocumentoDesviacion, { IAddDocumentosCausasEvidencias, ISearchDocsCausasEvidencias } from "../entities/IDocumentoDesviacion";
import { IFactoresPersonales } from "../entities/IFactoresPersonales";
import { IRequisitos, ISearchAllRequisitos } from "../entities/IRequisitos";
import { IRequisitoSistema, ISearchAllRequisitoSistema } from "../entities/IRequisitoSistema";
import { IResponseAPI } from "../entities/IResponseAPI";
import { ITipoCausaBasica } from "../entities/ITipoCausaBasica";
import { deleteAPI, getAPI, getAPIBlob, getAPIBlobByPost, postAPI } from "../helpers/httpHelper";
import {
  URL_DESVIACION,
  API_DESVIACION_GET_CALCULODESVIACIONES,
  API_DESVIACION_POST_DOCUMENTODESVIACION,
  API_DESVIACION_POST_ENVIARDESVIACION,
  API_DESVIACION_DELETE_DOCUMENTODESVIACION,
  API_DESVIACION_GET_DOCUMENTOSDESVIACION,
  API_DESVIACION_POST_INGRESODESVIACION,
  API_DESVIACION_GET_LISTADODESVIACIONESHOME,
  ROW_COUNT_MAX,
  ROW_COUNT,
  API_DESVIACION_GET_CONTENIDODOCUMENTODESVIACION,
  API_DESVIACION_GET_LISTADOCAUSASHOME,
  API_DESVIACION_GET_DESVIACION,
  API_DESVIACION_GET_CAUSASINMEDIATASXDESVIACION,
  API_DESVIACION_GET_CAUSASBASICASXDESVIACION,
  API_DESVIACION_GET_CAUSASSISTEMAXDESVIACION,
  API_DESVIACION_GET_TIPOSCAUSABASICA,
  API_DESVIACION_GET_FACTORESPERSONALES,
  API_DESVIACION_GET_CAPACIDADES,
  API_DESVIACION_POST_CAUSABASICA,
  API_DESVIACION_GET_DOCUMENTOSANALISISCAUSAL,
  API_DESVIACION_POST_DOCUMENTOANALISISCAUSAL,
  API_DESVIACION_DELETE_CAUSABASICA,
  API_DESVIACION_DELETE_CAUSAINMEDIATA,
  API_DESVIACION_DELETE_CAUSASISTEMA,
  API_DESVIACION_GET_TIPOREQUISITOSISTEMA,
  API_DESVIACION_GET_DESCRIPCIONREQUISITO,
  API_DESVIACION_POST_CAUSASISTEMA,
  API_DESVIACION_POST_CAUSAINMEDIATA,
  API_DESVIACION_DELETE_DOCUMENTOANALISISCAUSAL,
  API_DESVIACION_GET_TIPOSCAUSAINMEDIATA,
  API_DESVIACION_GET_ACTOCONDICIONSUBESTANDAR,
  API_DESVIACION_POST_GUARDARARBOLCAUSAL,
  API_DESVIACION_GET_DOCUMENTOSCAUSASEVIDENCIAS,
  API_DESVIACION_POST_GUARDARACCIONCAUSASISTEMA,
  API_DESVIACION_POST_GUARDARACCIONCAUSAINMEDIATA,
  API_DESVIACION_POST_GUARDARACCIONCAUSABASICA,
  API_DESVIACION_DELETE_DOCUMENTOCAUSASEVIDENCIAS,
  API_DESVIACION_POST_DOCUMENTOCAUSASEVIDENCIAS,
  API_DESVIACION_POST_ACCIONCIERRECAUSASISTEMA,
  API_DESVIACION_POST_ACCIONCIERRECAUSABASICA,
  API_DESVIACION_POST_ACCIONCIERRECAUSAINMEDIATA,
  API_DESVIACION_POST_DOCUMENTOPLANACCION,
  API_DESVIACION_GET_DOCUMENTOSPLANACCION,
  API_DESVIACION_POST_REGISTRARCIERRE,
  API_DESVIACION_DELETE_DOCUMENTOPLANACCION,
  API_DESVIACION_GET_LISTADOHISTORICO,
  API_DESVIACION_GET_REPORTESACCI,
  API_DESVIACION_GET_REPORTEDESVIACIONES,
  API_DESVIACION_GET_REPORTEACCB,
  API_DESVIACION_GET_REPORTESACCS,
  API_DESVIACION_GET_REPORTESABANA,
  API_DESVIACION_GET_EXCELREPORTEAC,
  API_DESVIACION_GET_EXCELREPORTESABANA,
  API_DESVIACION_GET_EXCELHISTORICODESVIACIONES,
  API_DESVIACION_GET_EXCELREPORTEDESVIACIONES,
  API_DESVIACION_POST_DESACTIVARDESVIACION,
  API_DESVIACION_POST_ELIMINARDESVIACION,
  API_DESVIACION_POST_DESACTIVARCAUSADESVIACION,
  API_DESVIACION_POST_ELIMINARCAUSADESVIACION,
} from "../helpers/variableHelper";
import { IDesactivarRegistro } from "../entities/ILogMantenedor";
interface IPaginationCausas { 
  cbpages: number;
  cipages: number;
  cspages: number;
}
export default class DesviacionService {
  public static async getDesvicacionByID(token: string, id: number): Promise<IDesviacion | null> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_DESVIACION}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: id,
          }
        )
      ).result;

      return result.data || null;
    } catch (e) {
      return {} as IDesviacion;
    }
  }

  public static async getEstadisticasHome(token: string, currUser: ICurrentUser): Promise<ICalculoDesviacion> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_CALCULODESVIACIONES}`,
          { Authorization: `Bearer ${token}` },
          {
            USUARIO: currUser?.email,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return {} as ICalculoDesviacion;
    }
  }

  public static async getListadoDesviacionesHome(
    token: string,
    searchDesviacion: ISearchByTipoBusquedaDesviaciones
  ): Promise<IResponseAPI<Array<IDesviacion>>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_LISTADODESVIACIONESHOME}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<Array<IDesviacion>>;
    }
  }

  public static async getListadoCausasHome(
    token: string,
    searchDesviacion: ISearchByTipoBusqueda
  ): Promise<IResponseAPI<ICausasAsignadasYCompletadas> & IPaginationCausas> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_LISTADOCAUSASHOME}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<ICausasAsignadasYCompletadas> & IPaginationCausas;
    }
  }

  public static async ingresoDesviacion(token: string, value: Partial<IDesviacion>): Promise<number> {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_INGRESODESVIACION}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data.data;
    } catch (error) {
      console.error(error);
      return -1;
    }
  }

  public static async enviarDesviacion(token: string, value: IEnviarDesviacion) {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_ENVIARDESVIACION}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async addDocumentosDesviacion(token: string, value: Partial<IDocumentoDesviacion>) {
    try {
      const formData = new FormData();
      formData.append("ID_TIPO_DOCUMENTO", value.ID_TIPO_DOCUMENTO?.toString() || "");
      formData.append("ID_DESVIACION", value.ID_DESVIACION?.toString() || "");
      formData.append("DESCRIPCION", value.DESCRIPCION as string);
      formData.append("FILE", value.FILE);
      delete value.FILE;
      let result = await postAPI(
        `${URL_DESVIACION}${API_DESVIACION_POST_DOCUMENTODESVIACION}`,
        formData,
        { Authorization: `Bearer ${token}` },
        value
      );

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async getDocumentosDesviacion(
    token: string,
    query: Partial<IDocumentoDesviacion>
  ): Promise<IResponseAPI<Array<IDocumentoDesviacion>>> {
    if (!query.PAGINA) {
      query.PAGINA = 1;
    }
    if (!query.PAGINADO) {
      query.PAGINADO = ROW_COUNT;
    }
    if (!query.ORDENADOPOR) {
      query.ORDENADOPOR = "ID";
    }
    if (!query.ORIENTACION) {
      query.ORIENTACION = "DESC";
    }

    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_DOCUMENTOSDESVIACION}`,
          { Authorization: `Bearer ${token}` },
          {
            ...query,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (error) {
      return {
        data: [],
        message: "",
        pages: 0,
        resultCode: 500,
      };
    }
  }

  public static async deleteDocumentoDesviacion(token: string, idDocumento: number): Promise<ICalculoDesviacion> {
    try {
      let resultCalculoHome = (
        await deleteAPI(
          `${URL_DESVIACION}${API_DESVIACION_DELETE_DOCUMENTODESVIACION}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: idDocumento,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return {} as any;
    }
  }

  public static getContenidoArchivo = async (token: string, ruta: string) => {
    try {
      let r = await getAPIBlob(
        `${URL_DESVIACION}${API_DESVIACION_GET_CONTENIDODOCUMENTODESVIACION}`,
        { Authorization: `Bearer ${token}` },
        {
          RUTA: ruta,
        }
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = ruta.split("/")?.pop() || ruta;
      fileLink.click();
    } catch (e) {
      console.log(e);
    }
  };

  public static async getListadoCausaInmediata(
    token: string,
    searchDesviacion: { ID: number } & ISearch
  ): Promise<IResponseAPI<Array<ICausaInmediata>> & IPaginationCausas> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_CAUSASINMEDIATASXDESVIACION}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<Array<ICausaInmediata>> & IPaginationCausas;
    }
  }

  public static async getListadoCausaBasica(
    token: string,
    searchDesviacion: { ID: number } & ISearch
  ): Promise<IResponseAPI<Array<ICausaBasica>> & IPaginationCausas> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_CAUSASBASICASXDESVIACION}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<Array<ICausaBasica>> & IPaginationCausas;
    }
  }

  public static async getListadoCausaSistema(
    token: string,
    searchDesviacion: { ID: number } & ISearch
  ): Promise<IResponseAPI<Array<ICausaSistema>> & IPaginationCausas> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_CAUSASSISTEMAXDESVIACION}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<Array<ICausaSistema>> & IPaginationCausas;
    }
  }

  public static async getListadoTiposCausaBasica(token: string, searchDesviacion: ISearchAllTipoCausaBasica): Promise<Array<ITipoCausaBasica>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_TIPOSCAUSABASICA}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return [] as Array<ITipoCausaBasica>;
    }
  }

  public static async getListadoTiposCausaInmediata(token: string, searchDesviacion: ISearchAllTipoCausaBasica): Promise<Array<ITipoCausaBasica>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_TIPOSCAUSAINMEDIATA}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return [] as Array<ITipoCausaBasica>;
    }
  }

  public static async getListadoFactoresPersonales(
    token: string,
    searchDesviacion: ISearchAllFactoresPersonales
  ): Promise<Array<IFactoresPersonales>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_FACTORESPERSONALES}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return [] as Array<IFactoresPersonales>;
    }
  }

  public static async getListadoCapacidades(token: string, searchDesviacion: ISearchAllCapacidad): Promise<Array<ICapacidades>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_CAPACIDADES}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (error) {
      console.error(error);
      return [] as Array<ICapacidades>;
    }
  }

  public static async postCausaBasica(token: string, value: IAddCausaBasica): Promise<number> {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_CAUSABASICA}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data;
    } catch (error) {
      console.error(error);
      return -1;
    }
  }

  public static async postCausaInmediata(token: string, value: IAddCausaInmediata): Promise<number> {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_CAUSAINMEDIATA}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data.data;
    } catch (error) {
      console.error(error);
      return -1;
    }
  }

  public static async postCausaSistema(token: string, value: IAddCausaSistema): Promise<number> {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_CAUSASISTEMA}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data;
    } catch (error) {
      console.error(error);
      return -1;
    }
  }

  public static async postDocumentoAnalisisCausal(token: string, value: Partial<IDocumentoDesviacion>) {
    try {
      const formData = new FormData();
      formData.append("ID_TIPO_DOCUMENTO", value.ID_TIPO_DOCUMENTO?.toString() || "");
      formData.append("ID_DESVIACION", value.ID_DESVIACION?.toString() || "");
      formData.append("DESCRIPCION", value.DESCRIPCION as string);
      formData.append("FILE", value.FILE);
      delete value.FILE;
      let result = await postAPI(
        `${URL_DESVIACION}${API_DESVIACION_POST_DOCUMENTOANALISISCAUSAL}`,
        formData,
        { Authorization: `Bearer ${token}` },
        value
      );

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async getListadoDocumentosAnalisisCausal(
    token: string,
    searchDesviacion: ISearchDocumentosAnalisisCausal
  ): Promise<IResponseAPI<Array<ISearchDocumentosAnalisisCausal>>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_DOCUMENTOSANALISISCAUSAL}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome;
    } catch (e) {
      return {} as IResponseAPI<Array<ISearchDocumentosAnalisisCausal>>;
    }
  }

  public static async deleteDocumentoAnalisisCausal(token: string, idDocumento: number): Promise<ICalculoDesviacion> {
    try {
      let resultCalculoHome = (
        await deleteAPI(
          `${URL_DESVIACION}${API_DESVIACION_DELETE_DOCUMENTOANALISISCAUSAL}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: idDocumento,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      console.log(e);
      return {} as any;
    }
  }

  public static async getContenidoDocumentoAnalisCausal(token: string, url: string) {
    return await this.getContenidoArchivo(token, url);
  }

  public static async deleteCausaBasica(token: string, id: number) {
    try {
      let resultDelete = (
        await deleteAPI(
          `${URL_DESVIACION}${API_DESVIACION_DELETE_CAUSABASICA}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: id,
          }
        )
      ).result;

      return resultDelete.data;
    } catch (e) {
      console.log(e);
    }
  }
  public static async deleteCausaInmediata(token: string, id: number) {
    try {
      let resultDelete = (
        await deleteAPI(
          `${URL_DESVIACION}${API_DESVIACION_DELETE_CAUSAINMEDIATA}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: id,
          }
        )
      ).result;

      return resultDelete.data;
    } catch (e) {
      console.log(e);
    }
  }
  public static async deleteCausaSistema(token: string, id: number) {
    try {
      let resultDelete = (
        await deleteAPI(
          `${URL_DESVIACION}${API_DESVIACION_DELETE_CAUSASISTEMA}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: id,
          }
        )
      ).result;

      return resultDelete.data;
    } catch (e) {
      console.log(e);
    }
  }

  public static async getListadoTipoRequisitoSistema(token: string, search: ISearchAllRequisitos): Promise<Array<IRequisitos>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_TIPOREQUISITOSISTEMA}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result.data;
    } catch (e) {
      return [] as Array<IRequisitos>;
    }
  }

  public static async getDescripcionRequisito(token: string, search: ISearchAllRequisitoSistema): Promise<Array<IRequisitoSistema>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_DESCRIPCIONREQUISITO}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result.data;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  public static async getListadoActoCondicionSubestandar(
    token: string,
    search: ISearchAllActoCondicionSubestandar
  ): Promise<Array<IActoCondicionSubestandar>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_ACTOCONDICIONSUBESTANDAR}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result.data;
    } catch (e) {
      return [] as Array<IActoCondicionSubestandar>;
    }
  }
  public static async postGuardarArbolCausal(token: string, value: IArbolCausal): Promise<number> {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_GUARDARARBOLCAUSAL}`, value, {
        Authorization: `Bearer ${token}`,
      });

      return result.result.data;
    } catch (error) {
      console.error(error);
      return -1;
    }
  }

  public static async getDocumentosCausasEvidencias(
    token: string,
    search: ISearchDocsCausasEvidencias
  ): Promise<IResponseAPI<Array<IDocumentoDesviacion>>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_DOCUMENTOSCAUSASEVIDENCIAS}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return {} as IResponseAPI<Array<IDocumentoDesviacion>>;
    }
  }
  public static async postDocumentoCausaEvidencia(token: string, value: Partial<IAddDocumentosCausasEvidencias>) {
    try {
      const formData = new FormData();
      formData.append("ID_DESVIACION", value.ID_DESVIACION?.toString() || "");
      formData.append("DESCRIPCION", value.DESCRIPCION as string);
      formData.append("FILE", value.FILE);
      delete value.FILE;
      let result = await postAPI(
        `${URL_DESVIACION}${API_DESVIACION_POST_DOCUMENTOCAUSASEVIDENCIAS}`,
        formData,
        { Authorization: `Bearer ${token}` },
        value
      );

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }
  public static async deleteDocumentoCausaEvidencia(token: string, idDocumento: number): Promise<ICalculoDesviacion> {
    try {
      let resultCalculoHome = (
        await deleteAPI(
          `${URL_DESVIACION}${API_DESVIACION_DELETE_DOCUMENTOCAUSASEVIDENCIAS}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: idDocumento,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (error) {
      console.error(error);
      return {} as any;
    }
  }
  public static async postGuardarAccionCausaBasica(token: string, value: ICausa): Promise<Array<IDocumentoDesviacion>> {
    try {
      let result = (await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_GUARDARACCIONCAUSABASICA}`, value, { Authorization: `Bearer ${token}` }))
        .result;

      return result.result.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public static async postGuardarAccionCausaInmediata(token: string, value: ICausa): Promise<Array<IDocumentoDesviacion>> {
    try {
      let result = (await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_GUARDARACCIONCAUSAINMEDIATA}`, value, { Authorization: `Bearer ${token}` }))
        .result;

      return result.result.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public static async postGuardarAccionCausaSistema(token: string, value: ICausa): Promise<Array<IDocumentoDesviacion>> {
    try {
      let result = (await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_GUARDARACCIONCAUSASISTEMA}`, value, { Authorization: `Bearer ${token}` }))
        .result;

      return result.result.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public static async postAccionCierreCausaBasica(token: string, value: ICausa): Promise<Array<IDocumentoDesviacion>> {
    try {
      let result = (await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_ACCIONCIERRECAUSABASICA}`, value, { Authorization: `Bearer ${token}` }))
        .result;

      return result.result.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public static async postAccionCierreCausaInmediata(token: string, value: ICausa): Promise<Array<IDocumentoDesviacion>> {
    try {
      let result = (await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_ACCIONCIERRECAUSAINMEDIATA}`, value, { Authorization: `Bearer ${token}` }))
        .result;

      return result.result.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public static async postAccionCierreCausaSistema(token: string, value: ICausa): Promise<Array<IDocumentoDesviacion>> {
    try {
      let result = (await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_ACCIONCIERRECAUSASISTEMA}`, value, { Authorization: `Bearer ${token}` }))
        .result;

      return result.result.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public static async postDocumentoPlanAccion(token: string, value: Partial<IAddDocumentosCausasEvidencias>) {
    try {
      const formData = new FormData();
      formData.append("ID_DESVIACION", value.ID_DESVIACION?.toString() || "");
      formData.append("DESCRIPCION", value.DESCRIPCION as string);
      formData.append("FILE", value.FILE);
      delete value.FILE;
      let result = await postAPI(
        `${URL_DESVIACION}${API_DESVIACION_POST_DOCUMENTOPLANACCION}`,
        formData,
        { Authorization: `Bearer ${token}` },
        value
      );

      return result.result.data;
    } catch (error) {
      console.error(error);
    }
  }

  public static async getListadoDocumentosPlanAccion(
    token: string,
    searchDesviacion: ISearchDocumentosAnalisisCausal
  ): Promise<Array<IDocumentoDesviacion>> {
    try {
      let resultCalculoHome = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_DOCUMENTOSPLANACCION}`,
          { Authorization: `Bearer ${token}` },
          {
            ...searchDesviacion,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (e) {
      return [] as Array<IDocumentoDesviacion>;
    }
  }

  public static async deleteDocumentoPlanAccion(token: string, idDocumento: number): Promise<ICalculoDesviacion> {
    try {
      let resultCalculoHome = (
        await deleteAPI(
          `${URL_DESVIACION}${API_DESVIACION_DELETE_DOCUMENTOPLANACCION}`,
          { Authorization: `Bearer ${token}` },
          {
            ID: idDocumento,
          }
        )
      ).result;

      return resultCalculoHome.data;
    } catch (error) {
      console.error(error);
      return {} as any;
    }
  }

  public static async postCierreDesviacion(token: string, value: ISetCierreDesviacion): Promise<Array<IDocumentoDesviacion>> {
    try {
      let result = (await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_REGISTRARCIERRE}`, value, { Authorization: `Bearer ${token}` })).result;

      return result.result.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  public static async getListadoHistorico(token: string, search: ISearchByHistoricoDesviacion) {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_LISTADOHISTORICO}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return false;
    }
  }

  public static async getReporteDesviacion(token: string, search: ISearchByReporteDesviacion): Promise<IResponseAPI<Array<any>>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_REPORTEDESVIACIONES}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return {} as IResponseAPI<Array<any>>;
    }
  }

  public static async getReporteAnalisisCausalCB(token: string, search: ISearchByReporteACCausasBasicas): Promise<IResponseAPI<Array<any>>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_REPORTEACCB}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return {} as IResponseAPI<Array<any>>;
    }
  }

  public static async getReporteAnalisisCausalCI(token: string, search: ISearchByReporteACCausasInmediatas): Promise<IResponseAPI<Array<any>>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_REPORTESACCI}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return {} as IResponseAPI<Array<any>>;
    }
  }
  public static async getReporteAnalisisCausalCS(token: string, search: ISearchByReporteACCausasSistema): Promise<IResponseAPI<Array<any>>> {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_REPORTESACCS}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return {} as IResponseAPI<Array<any>>;
    }
  }
  public static async getReporteSabana(token: string, search: ISearchByReporteDesviacion) {
    try {
      let result = (
        await getAPI(
          `${URL_DESVIACION}${API_DESVIACION_GET_REPORTESABANA}`,
          { Authorization: `Bearer ${token}` },
          {
            ...search,
          }
        )
      ).result;

      return result;
    } catch (e) {
      return {} as any;
    }
  }

  public static async getExcelReporteDesviaciones(token: string, search: ISearchByReporteDesviacion): Promise<void> {
    try {
      let r = await getAPIBlob(
        `${URL_DESVIACION}${API_DESVIACION_GET_EXCELREPORTEDESVIACIONES}`,
        { Authorization: `Bearer ${token}` },
        {
          ...search,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT_MAX,
        }
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = "Reporte_Desviaciones.xlsx";
      fileLink.click();
    } catch (e) {
      console.log(e);
    }
  }

  public static async getExcelHistoricoDesviaciones(token: string, search: ISearchByExcelReporteHistoricoDesviacion): Promise<void> {
    try {
      let r = await getAPIBlob(
        `${URL_DESVIACION}${API_DESVIACION_GET_EXCELHISTORICODESVIACIONES}`,
        { Authorization: `Bearer ${token}` },
        {
          ...search,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT_MAX,
        }
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = "Reporte histórico de desviaciones.xlsx";
      fileLink.click();
    } catch (e) {
      console.log(e);
    }
  }

  public static async getExcelReporteAC(token: string, search: ISearchByReporteAnalisisCausal): Promise<void> {
    try {
      let r = await getAPIBlobByPost(
        // `${URL_DESVIACION}${API_DESVIACION_GET_EXCELREPORTEAC}?${qs.stringify(search)}`,
        `${URL_DESVIACION}${API_DESVIACION_GET_EXCELREPORTEAC}`,
        { Authorization: `Bearer ${token}` },
        search
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = "Reporte Análisis Causal.xlsx";
      fileLink.click();
    } catch (e) {
      console.log(e);
    }
  }

  public static async getExcelReporteSabana(token: string, search: ISearchByReporteSabanaDesviacion): Promise<void> {
    try {
      let r = await getAPIBlob(
        `${URL_DESVIACION}${API_DESVIACION_GET_EXCELREPORTESABANA}`,
        { Authorization: `Bearer ${token}` },
        {
          ...search,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT_MAX,
        }
      );
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = "Reporte sábana de desviaciones.xlsx";
      fileLink.click();
    } catch (e) {
      console.log(e);
    }
  }

  public static async desactivarRegistro(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_DESACTIVARDESVIACION}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarRegistroDesviacion(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${URL_DESVIACION}${API_DESVIACION_POST_ELIMINARDESVIACION}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async desactivarCausaRegistro(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await postAPI(`${URL_DESVIACION}${API_DESVIACION_POST_DESACTIVARCAUSADESVIACION}`, value, {
        Authorization: `Bearer ${token}`,
      });
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }

  public static async eliminarCausaRegistroDesviacion(token: string, value: IDesactivarRegistro): Promise<number> {
    try {
      let result = await deleteAPI(
        `${URL_DESVIACION}${API_DESVIACION_POST_ELIMINARCAUSADESVIACION}`,
        {
          Authorization: `Bearer ${token}`,
        },
        value
      );
      return result.result.data.data;
    } catch (error: any) {
      console.error(error);
      return -1;
    }
  }
}
